package cz.lhoracek.mapl

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

object DeepLinkHandler {
    private val _pendingUrl = MutableStateFlow<String?>(null)
    val pendingUrl: StateFlow<String?> = _pendingUrl.asStateFlow()

    fun deliver(url: String) {
        _pendingUrl.value = url
    }

    fun consume() {
        _pendingUrl.value = null
    }
}

fun parseDeepLinkUrl(url: String): String? {
    if (!url.startsWith("mapl://join/")) return null
    val sessionId = url.removePrefix("mapl://join/").trimEnd('/')
    return sessionId.ifBlank { null }
}
